import { useState } from 'react';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Intro from './components/Intro/Intro';
import Services from './components/Services/Services';
import About from './components/About/About';
import Pricing from './components/Pricing/Pricing';
import Gallery from './components/Gallery/Gallery';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import BookNowButton from './components/BookNowButton/BookNowButton';
import LanguageSwitcher from './components/LanguageSwitcher/LanguageSwitcher';
import ChatBot from './components/ChatBot/ChatBot';
import './App.css';

function App() {
  const [language, setLanguage] = useState('en');

  return (
    <div className="App">
      <Header language={language} />
      <Hero language={language} />
      <Intro language={language} />
      <Services language={language} />
      <Pricing language={language} />
      <About language={language} />
      <Gallery language={language} />
      <Contact language={language} />
      <Footer language={language} />
      <BookNowButton language={language} />
      <LanguageSwitcher currentLang={language} onLanguageChange={setLanguage} />
      <ChatBot language={language} />
    </div>
  );
}

export default App;
